(function () {
  const DESKTOP_MQ = window.matchMedia("(min-width: 768px)");
  const TILE_SELECTOR = ".main-image-slide";
  const HIDDEN_CLASS = "hidde-image-main-to-show";
  const ZOOMED_CLASS = "_zoomed";
  const ARIA_ATTRIBUTES = ["role", "tabindex", "aria-pressed", "aria-label", "aria-describedby"];
  const PAN_STEP = 5;
  const HI_RES_WIDTH = 2400;

  function isVideoTile(tile) {
    const type = tile.dataset.mediaType || "";
    return tile.classList.contains("main-image-slide--video") || type === "video" || type === "external_video";
  }

  function init() {
    const slider = document.querySelector(".product-main-slider[data-zoom-mode='inline']");
    if (!slider || slider.dataset.inlineZoomReady) {
      return;
    }
    slider.dataset.inlineZoomReady = "true";

    const sectionRoot = slider.closest(".shopify-section");
    const sectionId = sectionRoot ? sectionRoot.id.replace("shopify-section-", "") : null;
    const controller = new AbortController();
    const { signal } = controller;
    const scale = parseFloat(slider.dataset.zoomScale) || 3;
    const labelTemplate = slider.dataset.zoomLabel || "[alt], image [index] of [total]";
    const altFallback = slider.dataset.zoomAltFallback || "Product image";
    const hintId = slider.dataset.zoomHintId || "";
    let zoomedTile = null;
    let syncScheduled = false;

    function tileImage(tile) {
      return tile.querySelector("img");
    }

    function isImageTile(tile) {
      return Boolean(tile) && !isVideoTile(tile) && Boolean(tileImage(tile));
    }

    function visibleTiles() {
      return Array.from(slider.querySelectorAll(`${TILE_SELECTOR}:not(.${HIDDEN_CLASS})`));
    }

    function setOrigin(tile, xPercent, yPercent) {
      const img = tileImage(tile);
      if (!img) {
        return;
      }
      const x = Math.min(Math.max(xPercent, 0), 100);
      const y = Math.min(Math.max(yPercent, 0), 100);
      img.style.transformOrigin = `${x}% ${y}%`;
      tile.dataset.zoomX = x;
      tile.dataset.zoomY = y;
    }

    function originFromEvent(tile, event) {
      const rect = tile.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        return;
      }
      setOrigin(tile, ((event.clientX - rect.left) / rect.width) * 100, ((event.clientY - rect.top) / rect.height) * 100);
    }

    function loadHiRes(img) {
      if (img.dataset.hiResLoaded) {
        return;
      }
      let url;
      try {
        url = new URL(img.currentSrc || img.src, window.location.href);
      } catch (error) {
        return;
      }
      const onShopifyCdn = /cdn\.shopify\.com$/.test(url.hostname) || url.pathname.startsWith("/cdn/");
      if (!onShopifyCdn) {
        return;
      }
      img.dataset.hiResLoaded = "true";
      url.searchParams.set("width", String(HI_RES_WIDTH));
      const preload = new Image();
      preload.onload = () => {
        img.src = url.href;
      };
      preload.onerror = () => {
        delete img.dataset.hiResLoaded;
      };
      preload.src = url.href;
    }

    function setAttr(element, name, value) {
      if (element.getAttribute(name) !== value) {
        element.setAttribute(name, value);
      }
    }

    function setTileLabel(tile, index, total) {
      const img = tileImage(tile);
      // Rebuilt tiles carry the image URL as alt, which is useless to a screen reader.
      const alt = img && img.alt && !/^https?:\/\//.test(img.alt) ? img.alt : altFallback;
      setAttr(tile, "aria-label", labelTemplate.replace("[alt]", alt).replace("[index]", index).replace("[total]", total));
    }

    function syncTileRoles() {
      const visible = visibleTiles();
      slider.querySelectorAll(TILE_SELECTOR).forEach((tile) => {
        if (!isImageTile(tile)) {
          return;
        }
        if (!DESKTOP_MQ.matches) {
          // Only undo our own attributes: on mobile Swiper's a11y module owns role/aria on the slides.
          if (tile.dataset.zoomA11y) {
            ARIA_ATTRIBUTES.forEach((name) => tile.removeAttribute(name));
            delete tile.dataset.zoomA11y;
          }
          return;
        }
        // A real <button> would break the mobile Swiper swipe and the grid tile, so the tile itself takes the role.
        tile.dataset.zoomA11y = "true";
        setAttr(tile, "role", "button");
        setAttr(tile, "tabindex", "0");
        setAttr(tile, "aria-pressed", tile === zoomedTile ? "true" : "false");
        if (hintId) {
          setAttr(tile, "aria-describedby", hintId);
        }
        const index = visible.indexOf(tile);
        if (index !== -1) {
          setTileLabel(tile, index + 1, visible.length);
        }
      });
      if (!zoomedTile) {
        return;
      }
      if (!slider.contains(zoomedTile) || zoomedTile.classList.contains(HIDDEN_CLASS)) {
        unzoom();
      } else {
        slider.dataset.zoomedSlide = String(visible.indexOf(zoomedTile) + 1);
      }
    }

    function scheduleSync() {
      if (syncScheduled) {
        return;
      }
      syncScheduled = true;
      requestAnimationFrame(() => {
        syncScheduled = false;
        syncTileRoles();
      });
    }

    function unzoom() {
      if (!zoomedTile) {
        return;
      }
      const img = tileImage(zoomedTile);
      if (img) {
        img.style.transform = "";
      }
      zoomedTile.classList.remove(ZOOMED_CLASS);
      zoomedTile.setAttribute("aria-pressed", "false");
      zoomedTile = null;
      slider.removeAttribute("data-zoomed-slide");
    }

    function zoom(tile) {
      if (zoomedTile && zoomedTile !== tile) {
        unzoom();
      }
      const img = tileImage(tile);
      if (!img) {
        return;
      }
      if (!img.style.transformOrigin) {
        setOrigin(tile, 50, 50);
      }
      img.style.transform = `scale(${scale})`;
      tile.classList.add(ZOOMED_CLASS);
      tile.setAttribute("aria-pressed", "true");
      zoomedTile = tile;
      slider.dataset.zoomedSlide = String(visibleTiles().indexOf(tile) + 1);
      loadHiRes(img);
    }

    function toggle(tile) {
      if (zoomedTile === tile) {
        unzoom();
      } else {
        zoom(tile);
      }
    }

    function tileFromEvent(event) {
      const tile = event.target.closest(TILE_SELECTOR);
      return tile && slider.contains(tile) && isImageTile(tile) ? tile : null;
    }

    slider.addEventListener("click", (event) => {
      if (!DESKTOP_MQ.matches) {
        return;
      }
      const tile = tileFromEvent(event);
      if (!tile) {
        return;
      }
      originFromEvent(tile, event);
      toggle(tile);
    }, { signal });

    slider.addEventListener("mousemove", (event) => {
      if (!DESKTOP_MQ.matches) {
        return;
      }
      const tile = tileFromEvent(event);
      if (tile) {
        originFromEvent(tile, event);
      }
    }, { signal });

    slider.addEventListener("mouseout", (event) => {
      if (!zoomedTile) {
        return;
      }
      const tile = event.target.closest(TILE_SELECTOR);
      if (tile === zoomedTile && !tile.contains(event.relatedTarget)) {
        unzoom();
      }
    }, { signal });

    slider.addEventListener("keydown", (event) => {
      if (!DESKTOP_MQ.matches) {
        return;
      }
      const tile = tileFromEvent(event);
      if (!tile) {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggle(tile);
        return;
      }
      if (event.key === "Escape" || event.key === "Tab") {
        unzoom();
        return;
      }
      if (zoomedTile !== tile) {
        return;
      }
      const x = parseFloat(tile.dataset.zoomX) || 50;
      const y = parseFloat(tile.dataset.zoomY) || 50;
      const pan = { ArrowLeft: [x - PAN_STEP, y], ArrowRight: [x + PAN_STEP, y], ArrowUp: [x, y - PAN_STEP], ArrowDown: [x, y + PAN_STEP] }[event.key];
      if (pan) {
        event.preventDefault();
        setOrigin(tile, pan[0], pan[1]);
      }
    }, { signal });

    // Tiles are rebuilt on colour switch; on mobile the Swiper churns classes, so the sync only runs on desktop.
    const observer = new MutationObserver(() => {
      if (DESKTOP_MQ.matches) {
        scheduleSync();
      }
    });
    observer.observe(slider.querySelector("#swiper-main-image-content") || slider, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });

    DESKTOP_MQ.addEventListener("change", () => {
      unzoom();
      syncTileRoles();
    }, { signal });
    syncTileRoles();

    document.addEventListener("shopify:section:unload", (event) => {
      if (sectionId && event.detail && String(event.detail.sectionId) !== sectionId) {
        return;
      }
      observer.disconnect();
      unzoom();
      controller.abort();
    }, { signal });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
